import styled from 'styled-components'

export const SHomePageLayout = styled.div`
  display: flex;
  flex-direction: column;
`
